import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { XpressUserProfile } from 'app/models/users/XpressUserProfile';
import { MenuItem, MessageService } from 'primeng/api';
import { GenderEnum, GenderModel, PayServiceTypeEnum, PayServiceTypeModel, XpressUserRoleEnum } from 'app/models';
import moment from 'moment';
import { AppDataService, XpressUserService } from 'app/services';
import { MenuHomeEnum } from 'app/components/home';
import { Utils } from 'app/utils';
import { DocumentImageComponent } from './document-image/document-image.component';

@Component({
  selector: 'profile-detail',
  templateUrl: './profile-detail.component.html',
  styleUrls: ['./profile-detail.component.scss']
})
export class ProfileDetailComponent implements OnInit {

  @Input()
  public profile: XpressUserProfile = new XpressUserProfile();

  @Input()
  public initialProfile: XpressUserProfile = new XpressUserProfile();

  @Output()
  public hideProfile = new EventEmitter<boolean>();

  @Output()
  public profileChanged = new EventEmitter<any[]>();

  @ViewChild(DocumentImageComponent) documentImageComponent!: DocumentImageComponent;

  protected readonly moment = moment;
  public avatarHover = false;
  public infoItems: any = [];
  public activeImgIndex: number = 0;
  public displayImg: boolean = false;
  public showUploadDocumentsPopup: boolean = false;

  genderList = GenderModel.GenderList;
  bankList = PayServiceTypeModel.PayServiceTypeList.filter(x => x.value === PayServiceTypeEnum.BaUbp || x.value === PayServiceTypeEnum.BaBpi);

  public govIdsVisible: boolean = false;
  public DTIVisible: boolean = false;
  public BIRVisible: boolean = false;
  public LTFRBVisible: boolean = false;
  public PermitVisible: boolean = false;
  public isSpinnerVisible: boolean = false;

  public menuPermissionActive!: string;

  public menuItems: MenuItem[] = [
  ];

  public activeItem: MenuItem = this.menuItems[0];
  public showEdit: boolean = false;
  public discardConfirmDialog: boolean = false;
  public editDialog: boolean = false;

  //DocsGalleries
  public govIdsImgs: any = [];
  public DTIImgs: any = [];
  public BIRImgs: any = [];
  public LTFRBImgs: any = [];
  public PermitImgs: any = [];
  public tempProfile: XpressUserProfile = new XpressUserProfile();
  public temporaryProfile: XpressUserProfile = new XpressUserProfile();

  public imageOptions: any[] = [
      {
          breakpoint: '1500px',
          numVisible: 5
      },
      {
          breakpoint: '1024px',
          numVisible: 3
      },
      {
          breakpoint: '768px',
          numVisible: 2
      },
      {
          breakpoint: '560px',
          numVisible: 1
      }
  ];

  constructor(
    private appData: AppDataService,
    private messageService: MessageService,
    private xpressUserService: XpressUserService
  ) {
  }

  ngOnInit(): void {
    localStorage.setItem(JSON.stringify(this.initialProfile), 'initialProfile');
    if(this.isOperator()){
      this.menuItems.push({
        id: ProfileTab.LegalDocs,
        label: 'Legal Docs'
      },
      {
        id: ProfileTab.Security,
        label: 'Security'
      });
    } else {
      this.menuItems.push(
      {
        id: ProfileTab.Security,
        label: 'Security'
      });
    }
    this.activeItem = this.menuItems[0];
  }

  public handleInputProfileImgClick(id: string): void {
    document.getElementById(id)?.click();
  }

  public showPhotoImageModal() {
    this.infoItems = [{ value: this.profile.ImageUrl}];
    this.displayImg = true;
  }

  public handleInputProfileImgChange(event: Event) {
    const target = event.target as HTMLInputElement;

    let file: File | null = null;
    if (target.files) {
        file = target.files[0];
    }

    if (!file) {
        return;
    }

    // Chech max file size 2MB
    if (file.size > 2097152) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
        return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
        if (e?.target?.result) {
            // Base64 string
            this.profile.ImageData = e.target.result.toString();
            this.profile.ImageUrl = e.target.result.toString();
        }
    };

    reader.readAsDataURL(file);
  }

  toggleUploadPopup() {
    this.showUploadDocumentsPopup = !this.showUploadDocumentsPopup;
  }

  isOperator() {
    return +this.appData.authData.roleId === XpressUserRoleEnum.Operator;
  }

  public showGovID(){
    if (this.profile.GovIdUrls.length < 1) {
        return;
    }
    this.govIdsVisible = true;
}

public showDTICertif(){
    if (this.profile.DTIorSECCertifUrls.length < 1) {
        return;
    }
    this.DTIVisible = true;
}

public showPermit(){
    if (this.profile.BusinessPermitUrls.length < 1) {
        return;
    }
    this.PermitVisible = true;
}

public showBIRCertif(){
    if (this.profile.BIRCertifUrls.length < 1) {
        return;
    }
    this.BIRVisible = true;
}

public showLTFRBCertif(){
    if (this.profile.LTFRBCertifUrls.length < 1) {
        return;
    }
    this.LTFRBVisible = true;
}

cancel(){
  this.hideProfile.emit(false);
}

public onActiveItemChange(item: any): void {
  this.activeItem = item;
}

public editDetails() {
  this.editDialog = true;
}

public discardChanges() {
  this.discardConfirmDialog = true;
}

public hideConfirmModal(event: boolean) {
  this.discardConfirmDialog = false;
  if(event){
    this.temporaryProfile = this.tempProfile;
  } else {
    this.temporaryProfile = new XpressUserProfile();
  }
  this.editDialog = event;
}

public hideProfileModal(event: XpressUserProfile){
  this.tempProfile = event;
  this.discardConfirmDialog = true;
  this.editDialog = false;
}

public updateUserProfile(saveOnlyImageLinks = false, profile?: XpressUserProfile) {
      this.isSpinnerVisible = true;
      this.profile.Id = +this.appData.authData.UserId;
      this.profile.SaveOnlyImageLinks = saveOnlyImageLinks;
      this.profile.TimeZoneOffset = Utils.getTimezoneOffset();
      this.xpressUserService.updateUserProfile(this.profile, this.messageService)
          .then(data => {
              this.isSpinnerVisible = false;
              if (!data.Success) {
                  if (saveOnlyImageLinks) {
                      this.documentImageComponent?.restoreDocumentsFromInitial();
                  }
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                  return;
              }
              this.profile.Sex = GenderEnum[this.profile.Gender];
              if (saveOnlyImageLinks) {
                  this.documentImageComponent?.applySavedDocuments();
              }
              this.xpressUserService.updateProfile(JSON.parse(JSON.stringify(this.profile)));
              this.profileChanged.emit(this.profile as any);
              this.messageService.add({ severity: 'success', summary: 'Update saved successfully', detail: 'Your changes have been applied and saved.' });
              this.editDialog = false;
              if (!saveOnlyImageLinks) {
                  this.showEdit = false;
              }
          })
          .catch(err => {
              this.isSpinnerVisible = false;
              if (saveOnlyImageLinks) {
                  this.documentImageComponent?.restoreDocumentsFromInitial();
              }
              throw err;
          });
  }

  updateUser(event: XpressUserProfile){
    this.profile = event;
    this.updateUserProfile(true);
  }

  public initGalleriesImages() {
    for (const url of this.profile.GovIdUrls) {
        this.govIdsImgs.push({ value: url});
    }
    for (const url of this.profile.DTIorSECCertifUrls) {
        this.DTIImgs.push({ value: url});
    }
    for (const url of this.profile.BIRCertifUrls) {
        this.BIRImgs.push({ value: url});
    }
    for (const url of this.profile.LTFRBCertifUrls) {
        this.LTFRBImgs.push({ value: url});
    }
    for (const url of this.profile.BusinessPermitUrls) {
        this.PermitImgs.push({ value: url});
    }
}

  protected readonly XpressUserRoleEnum = XpressUserRoleEnum;
  protected readonly Utils = Utils;
}

export enum ProfileTab {
  LegalDocs = '1',
  Security = '2'
}
